import {
  BackgroundImage,
  Box,
  Card,
  Divider,
  Group,
  Image,
  Indicator,
  Space,
  Stack,
  Text,
} from '@mantine/core';

import classes from './ReportContainer.module.css';

interface GTIReportCoverProps {
  subjectName?: string;
  reportLevel?: string;
  date?: string;
  visible?: boolean;
  children?: React.ReactNode;
  contentRef?: React.RefObject<HTMLDivElement | null>;
}

export function ReportContainer({
  subjectName = 'XXXXX',
  reportLevel = 'Screening Report',
  date = 'DD Month YYYY',
  visible = true,
  children,
  contentRef,
}: Readonly<GTIReportCoverProps>) {
  const textProps = {
    size: 'lg',
    c: 'white',
    fw: '700',
  };

  if (!visible) {
    return (
      <Card w={1000} mx="auto" withBorder p="xs" radius="xs" shadow="lg" ref={contentRef}>
        {children}
      </Card>
    );
  }
  return (
    <Card w={1000} mx="auto" withBorder p="xs" radius="xs" shadow="lg" ref={contentRef}>
      <BackgroundImage src="/assets/gti/background.jpg" className={classes.coverBackground}>
        <Stack>
          <Card.Section>
            <Box w="50%" p="xl" m="xl" className={classes.logoSection}>
              <Image src="/assets/gti/logo-primary-dark.svg" width="50%" />
            </Box>
          </Card.Section>
          <div className={classes.spaceBetweenLogoAndText} />
          <Card.Section>
            <Box p="xl" m="xl" className={classes.textSection}>
              <Text span {...textProps} c="var(--mantine-color-yellow-6)">
                SUBJECT NAME:{' '}
              </Text>
              <Text span {...textProps}>
                {subjectName}
              </Text>
              <Divider my="xs" w="50%" />
              <Text span {...textProps} c="var(--mantine-color-yellow-6)">
                REPORT LEVEL:{' '}
              </Text>
              <Text span {...textProps}>
                {reportLevel}
              </Text>
              <Divider my="xs" w="50%" />
              <Text span {...textProps} c="var(--mantine-color-yellow-6)">
                DATE:{' '}
              </Text>
              <Text span {...textProps}>
                {date}
              </Text>
            </Box>
          </Card.Section>
        </Stack>
      </BackgroundImage>

      <Indicator
        color="white"
        size="xl"
        offset={-25}
        radius="xs"
        zIndex={99}
        label={
          <Group p="sm">
            <Text {...textProps} c="var(--mantine-color-navy-9)" pl="xl">
              PRIVATE & CONFIDENTIAL
            </Text>
          </Group>
        }
        // @ts-ignore
        position="top-right"
      >
        <Box bg="var(--mantine-color-yellow-6)" p="xl" className={classes.disclaimerBox}>
          <Text size="xs" m="md">
            This report is private and confidential. It should be used solely by the client for whom
            the report was prepared.
            <br />
            In preparing this report, Ground Truth Intelligence and our Network Partners have used
            their reasonable care and skill and have endeavoured to include in this report and to
            base its analysis upon information that we believe to be relevant to the purposes of the
            report; however, no representation or warranty, express or implied, is made by Ground
            Truth Intelligence as to the accuracy or completeness of the information included in the
            report.
          </Text>
        </Box>
      </Indicator>
      <Space h="lg" />
      <div className={classes.pageBreak} />
      <Space h="xs" />
      <Box
        py="md"
        bg="var(--mantine-color-navy-9)"
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <Image src="/assets/gti/logo-primary-dark.svg" w="25%" mr="md" />
      </Box>
      <Card.Section>
        <Box p="xl">{children}</Box>
      </Card.Section>
      <Box
        py="md"
        bg="var(--mantine-color-navy-9)"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <Text size="md" fw="700" m="md" c="white">
          End of Report
        </Text>
      </Box>
      <Space h="xs" />
    </Card>
  );
}
